import { render, staticRenderFns } from "./RecipeItemIngredientCreate.vue?vue&type=template&id=ac69e870&scoped=true&"
import script from "./RecipeItemIngredientCreate.vue?vue&type=script&lang=js&"
export * from "./RecipeItemIngredientCreate.vue?vue&type=script&lang=js&"
import style0 from "./RecipeItemIngredientCreate.vue?vue&type=style&index=0&id=ac69e870&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac69e870",
  null
  
)

export default component.exports